const getMerchantName = () => window.location.pathname.split('/')[2];

export default getMerchantName;
